var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WhatTypeOfFramesField',_vm._g({attrs:{"field":"custom-dimension-4","choices":_vm.choices}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }